// Save cart in sessionStorage
export const saveCartToSession = (cart) => {
    sessionStorage.setItem("cart", JSON.stringify(cart));
  };
  
  // Load cart from sessionStorage
  export const getCartFromSession = () => {
    const cart = sessionStorage.getItem("cart");
    return cart ? JSON.parse(cart) : [];
  };
  
  // Add item to session cart
  export const addToSessionCart = (productId, variant = {}, quantity = 1) => {
    let cart = getCartFromSession();
  
    const index = cart.findIndex(
      (item) =>
        item.productId === productId &&
        JSON.stringify(item.variant) === JSON.stringify(variant)
    );
  
    if (index >= 0) {
      cart[index].quantity += quantity;
    } else {
      cart.push({ productId, variant, quantity });
    }
  
    saveCartToSession(cart);
    return cart;
  };
  
  // Get cart item count
  export const getSessionCartCount = () => {
    const cart = getCartFromSession();
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };
  